var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-infraestructura-configuracion-caracteristicas-subtipos-infraestructura-desktop"}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.listadoCaracteristciasSubtipoInfraestructura},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('opciones',{attrs:{"caracteristicaSubtipoInfraestructura":item}})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }